import {useEffect, useState} from "react";
import WorkerStatusBar from "../Common/WorkerStatusBar";
import OrderSideBar from "../OrderSideBar";
import MenuItemsSideBar from "../MenuItemsSideBar";
import {v4 as uuidv4} from 'uuid';
import {borderRadius, buttonColors, fontsSize} from "../UIElements/Elements";
import FormInput from "../UIElements/FormInput";
import PopUpMessage from "../Common/PopUpMessages/PopUpMessage";

const OrderTableView = () => {

    const [orderItems, setOrderItems] = useState([{
        id: "1",
        product_name: "Coca Cola",
        product_price: 70,
        quantity: 3
    }]);
    const [orderItemsToAdd, setOrderItemsToAdd] = useState([]);
    const [activeOrderItem, setActiveOrderItem] = useState(null);
    const [error, setError] = useState({message: null, statusCode: null});

    const handleAddToOrder = (id, productName, productId, productPrice, kotToPrint) => {
        const updatedItems = orderItemsToAdd.map(item => item.selected ? {...item, selected: false} : item);

        setOrderItemsToAdd(prevItems => [...updatedItems, {
            id: uuidv4(),
            product_name: productName,
            product_id: productId,
            product_price: productPrice,
            kot_to_print: kotToPrint,
            quantity: 1,
            selected: true
        }]);
    };
    const [orderedSum, setOrderedSum] = useState(0);
    const [toAddSum, setToAddSum] = useState(0);
    const totalSum = orderedSum + toAddSum;
    useEffect(() => {
        const sum = orderItemsToAdd.reduce((total, item) => total + item.quantity * item.product_price, 0);
        setToAddSum(sum);
    }, [orderItemsToAdd]);
    useEffect(() => {
        const sum = orderItems.reduce((total, item) => total + item.quantity * item.product_price, 0);
        setOrderedSum(sum);
    }, [orderItems]);


    return (<div
        className="w-full h-screen flex flex-col  items-start sm:items-center justify-center sm:justify-evenly text-white bg-cover overflow-hidden">
        <PopUpMessage errorMessage={error.message} statusCode={error.statusCode}></PopUpMessage>
        <WorkerStatusBar workerName={"Dardan Asani"} outletName={"Garden"}/>
        <OrderSideBar orderItems={orderItems} orderItemsToAdd={orderItemsToAdd}
                      setOrderItemsToAdd={setOrderItemsToAdd} setActiveOrderItem={setActiveOrderItem}
                      orderedSum={orderedSum} toAddSum={toAddSum}/>
        <MenuItemsSideBar onAddToOrder={handleAddToOrder} totalSum={totalSum}/>
        {activeOrderItem && (<div
            className="fixed top-0 left-0 w-full h-full bg-blue-400 bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-40">
            <div
                className={`w-[50vh] h-auto bg-white ${borderRadius.medium} py-[2vh] px-[3vh] relative flex justify-start items-center flex-col`}>
                <button
                    className="absolute top-2 right-3 text-black text-l"
                    onClick={() => {
                        setActiveOrderItem(null);
                        setError({message: null, statusCode: null});
                    }
                    }
                >
                    ✖
                </button>
                <h2 className={`${fontsSize.l} text-black`}>Order Details</h2>
                <div
                    className={`w-[100%] h-auto ${borderRadius.small} p-[2vh] mx-[2vh] text-black`}>

                    <FormInput type={"text"} placeholder={`Product: ${activeOrderItem.product_name}`}
                               readOnly={true} value={`${activeOrderItem.product_name}`}/>
                    <FormInput type={"text"} placeholder={`Price: ${activeOrderItem.product_price}`}
                               readOnly={true} value={`${activeOrderItem.product_price} den`}/>
                    <input onChange={(e) => {
                        const newQuantity = e.target.value;
                        setActiveOrderItem(prevItem => ({
                            ...prevItem, quantity: newQuantity
                        }));
                    }} value={`${activeOrderItem.quantity}`} type={"number"}
                           className={`w-full p-[1vh] mb-[1vh] border rounded focus:outline-none focus:ring-blue-400 ${fontsSize.m}`}
                           readOnly={false}/>
                    <textarea onChange={(e) => {

                        const newComment = e.target.value;
                        setActiveOrderItem(prevItem => ({
                            ...prevItem, comment: newComment
                        }));
                    }} placeholder={'Comment'} value={activeOrderItem.comment || ""}
                              className={`w-[100%] h-[10vh] p-[1vh] border rounded focus:outline-none focus:ring-blue-400 ${borderRadius.small} resize-none p-[1vh] ${fontsSize.m}`}>

                            </textarea>
                </div>
                <div onClick={() => {
                    if (isNaN(activeOrderItem.quantity) || activeOrderItem.quantity < 1) {
                        setError({message: "Invalid quantity for order item", statusCode: 400});
                        return;
                    } else {
                        setError({message: null, statusCode: null})
                    }
                    setOrderItemsToAdd(prevItems => prevItems.map(item => item.id === activeOrderItem.id ? {
                        ...item, quantity: activeOrderItem.quantity, comment: activeOrderItem.comment
                    } : item));
                    setActiveOrderItem(null);
                }}
                     className={`${buttonColors.success} w-[100%] h-[8vh] m-[1vh] flex justify-center items-center ${borderRadius.medium}`}>Save
                </div>
            </div>
        </div>)}


    </div>);
};

export default OrderTableView;
